import React, { useMemo } from 'react';
import { Collapse, Typography, Empty } from 'antd';
import { LoginOutlined, LogoutOutlined } from '@ant-design/icons';
import type { ProcessFuncCodeDetailDto } from '../../../../api/opmApi';
import SchemaConstraintEditor from './SchemaConstraintEditor';
import type { SchemaField } from './types';
import { jsonSchemaToFields, fieldsToJsonSchema } from './types';

const { Text } = Typography;

interface FunctionDefTabProps {
  definition: ProcessFuncCodeDetailDto | null;
  inputFields: SchemaField[];
  outputFields: SchemaField[];
  onInputFieldsChange: (fields: SchemaField[]) => void;
  onOutputFieldsChange: (fields: SchemaField[]) => void;
}

const FunctionDefTab: React.FC<FunctionDefTabProps> = ({
  definition,
  inputFields,
  outputFields,
  onInputFieldsChange,
  onOutputFieldsChange,
}) => {
  if (!definition) {
    return (
      <div style={{ padding: 40, textAlign: 'center' }}>
        <Empty description="暂无 Process 定义数据" />
      </div>
    );
  }

  const hasInput = inputFields.length > 0;
  const hasOutput = outputFields.length > 0;

  const collapseItems = [
    {
      key: 'input',
      label: (
        <span>
          <LoginOutlined style={{ marginRight: 8 }} />
          输入参数
          <Text type="secondary" style={{ marginLeft: 8, fontSize: 12 }}>
            ({inputFields.length} 个字段)
          </Text>
        </span>
      ),
      children: (
        <SchemaConstraintEditor
          fields={inputFields}
          onChange={onInputFieldsChange}
          title="输入"
          readOnlyStructure
        />
      ),
    },
    {
      key: 'output',
      label: (
        <span>
          <LogoutOutlined style={{ marginRight: 8 }} />
          输出参数
          <Text type="secondary" style={{ marginLeft: 8, fontSize: 12 }}>
            ({outputFields.length} 个字段)
          </Text>
        </span>
      ),
      children: (
        <SchemaConstraintEditor
          fields={outputFields}
          onChange={onOutputFieldsChange}
          title="输出"
          readOnlyStructure
          hideRequired
        />
      ),
    },
  ];

  return (
    <div style={{ padding: '8px 0' }}>
      <div style={{ marginBottom: 12 }}>
        <Text type="secondary" style={{ fontSize: 13 }}>
          参数结构由画板中的 OPM Link 关系自动推导，此处可编辑各字段的数据约束条件（是否必填、取值范围、枚举值等）。
        </Text>
      </div>

      <Collapse
        defaultActiveKey={['input', 'output']}
        items={collapseItems}
        bordered={false}
        style={{ background: 'transparent' }}
      />
    </div>
  );
};

export default FunctionDefTab;
